export default "__VITE_ASSET__CFnki$3H__"